import { BASE_TYPES } from "helpers/base"
import PropTypes from "prop-types"

export default function Benchmark({ id, name, type }) {
  switch (type) {
    case BASE_TYPES.portfolio:
    case BASE_TYPES.researchTopic:
      return <><span className="label">Benchmark: </span>{name}</>
    default:
      return <><span className="label">Benchmark: </span><span className="id">({id})</span> {name}</>
  }
}

Benchmark.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf(Object.values(BASE_TYPES)).isRequired,
}
